// extracted by mini-css-extract-plugin
module.exports = {"coverage":"coverage_coverage__fH45V"};